import { gql } from '@apollo/client';

export const GetChatsQuery = gql`
    query GetChats($type: ChatType) {
        getChats(type: $type) {
            id
            participants {
                id
                fullName
                roles
                student {
                    id
                    fullName
                }
                school {
                    id
                    shortName
                }
            }
            messages {
                id
                message
                sender {
                    id
                    fullName
                    roles
                    school {
                        id
                        fullName
                    }
                    student {
                        id
                        fullName
                    }
                }
                viewed
                createdAt
                updatedAt
            }
            owner {
                id
                fullName
                roles
            }
            type
            status
            createdAt
            updatedAt
        }
    }
`;
